import { sharedResolution } from '@public/src/shared_resolution';
import { DateService } from '@services/date.service';
import { v4 } from 'uuid';

export type KnownApplicationNotificationTypes = 'localPush' | 'banner';

export abstract class ApplicationNotification<T extends string = KnownApplicationNotificationTypes> {
	public readonly guid: string;
	public readonly timestamp: VisibaDate;
	public abstract readonly event: T;
	protected readonly dateService = sharedResolution.resolve(DateService);

	constructor(sid?: string) {
		this.timestamp = this.dateService.create();
		this.guid = sid ?? v4();
	}
}

export interface ApplicationNotificationSpecificationBase<_T extends ApplicationNotification> {
	guid?: string;
}
